
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'

import useTranslation from '../../../Hooks/UseTranslation'
import { useProgrammation } from '../../../Hooks/UseProgrammation'
import { updateTaskDate } from '../../../Services/ProgrammationManagerService'
import { updateTaskDateAction } from '../../../Redux/Actions/ProgrammationManagerActions'

import InputDate from '../components/InputDate'
import { getExpectedEndDate } from '../../../Helpers/ProgrammationHelper'
import { useProject } from '../../../Hooks/UseProject'

interface Props {
  label: string
  fieldName: string
  disabled?: boolean
}

const TaskDate = ({ label, fieldName, disabled }: Props) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened, patchItemOpened } = useProgrammation()
  const { project } = useProject()

  const { setEditingItem } = useProgrammation()

  const [ date, setDate ] = useState('')
  const [ isEstimate, setIsEstimate ] = useState(false)

  const validateDate = (date: any) => {

    if (itemOpened.type === 'hito' || itemOpened.type === 'reunion') {
      return true
    }

    if (fieldName === 'startsAt' && moment(date).isAfter(moment(itemOpened.endsAt), 'D')) {

      Swal.fire({
        title: t('ERROR:BadDate'),
        text: t('PROGRAMMATION_MANAGER:StartCanNotBeGreaterThanEndError'),
        icon: 'error',
        confirmButtonText: t('ERROR:CloseButton'),
        width: '400px',
      })

      return false
    } else if (fieldName === 'endsAt' && moment(date).isBefore(moment(itemOpened.startsAt), 'D')) {

      Swal.fire({
        title: t('ERROR:BadDate'),
        text: t('PROGRAMMATION_MANAGER:EndsAtLabelError'),
        icon: 'error',
        confirmButtonText: t('ERROR:CloseButton'),
        width: '400px',
      })

      return false
    }

    return true
  }

  const handleChangeDate = async (date: string) => {

    if (!validateDate(date)) return

    setDate(date)

    setEditingItem(true)

    const [ error, data ] = await updateTaskDate(itemOpened?._id, fieldName, date)

    setEditingItem(false)

    if (error) {
      return false;
    }

    patchItemOpened({
      [fieldName]: data.task[fieldName],
      executeDays: data.task.executeDays,
      startedAt: data.task.startedAt,
      endedAt: data.task.endedAt,
    })

    await dispatch(updateTaskDateAction(data.task, data.parentTask))
  }

  useEffect(() => {

    const getEstimatedEndDate = () => {

      const endDate = getExpectedEndDate(itemOpened.startedAt, itemOpened.executeDays, project.nonWorkingDays, true)
      setDate(moment(endDate).format('YYYY-MM-DD'))
    }

    const getDate = (date: string) => {

      const dateMoment = moment(date)

      setDate(dateMoment.format('YYYY-MM-DD'))
    }

    if (fieldName === 'endedAt' && !itemOpened.endedAt) {

      getEstimatedEndDate()
      setIsEstimate(true)
    } else {

      getDate(itemOpened[fieldName])
      setIsEstimate(false)
    }
  }, [itemOpened, fieldName])

  return (
    <Form.Group>
      <Form.Label>
        {t(label)}
      </Form.Label>
      <InputDate
        value={date || ''}
        onChange={handleChangeDate}
        placeholder="dd/mm/yyyy"
        disabled={disabled || isEstimate}
      />
    </Form.Group>
  )
}

export default TaskDate
